export default "__VITE_ASSET__n6GCkz1J__"